import { Link } from "react-router-dom";
import { BsArrowRight } from "react-icons/bs";
import SEO from "../../components/SEO";

function NotFoundPage() {
  return (
    <div className="w-full flex flex-1 flex-col bg-gradient-to-br from-cyan-100 to-fuchsia-200">
      <SEO
        title="Page Not Found"
        description="The page you are looking for does not exist or has moved."
        noIndex
      />
      <section className="max-w-3xl mx-auto w-full px-4 sm:px-5 py-20 md:py-28 text-center">
        <p className="text-sm font-medium uppercase tracking-widest text-purple-600 mb-4">Error 404</p>
        <h1 className="text-4xl md:text-5xl text-purple-800 leading-tight mb-6">We couldn't find that page</h1>
        <p className="text-lg text-gray-700 mb-8">
          The link may be broken or the page may have moved. You can head back home to get a quote, or track a parcel
          you've already sent.
        </p>
        <div className="flex flex-wrap justify-center gap-3">
          <Link
            to="/"
            className="inline-flex items-center gap-2 bg-purple-600 hover:bg-purple-700 text-white font-semibold px-6 py-3 rounded-full transition-colors"
          >
            Go to the homepage <BsArrowRight aria-hidden="true" />
          </Link>
          <Link
            to="/track-parcel"
            className="inline-flex items-center gap-2 bg-white hover:bg-purple-50 text-purple-700 font-semibold px-6 py-3 rounded-full border border-purple-200 transition-colors"
          >
            Track a parcel
          </Link>
        </div>
      </section>
    </div>
  );
}

export { NotFoundPage };
